import React, { useState } from "react";
import { Button } from "@mui/material";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import MediaThumbnail from "../part/MediaThumbnail";

import Translate from "../../components/part/Translate";

import CSSModules from "react-css-modules";
import style from "./InputImageWithPreview.module.scss";

var createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

export default CSSModules(InputImageWithPreview, { ...style }, { allowMultiple: true });

function InputImageWithPreview(props) {
  var fileRef = props.fileRef;

  const [fileSrcs, setFileSrcs] = useState([]);

  const handleChangeFile = (event) => {
    const dt = new DataTransfer();

    // ①イベントからfileの配列を受け取る
    var files = fileRef.current.files;

    var fileUrls = [];
    for (var i = 0; i < files.length; i++) {
      // ②createObjectURLで、files[0]を読み込む
      fileUrls[i] = files[i];
      // fileUrls[i] = createObjectURL(files[i]);
      dt.items.add(files[i]);
    }
    fileRef.current.files = dt.files;

    // ③setStateする！
    setFileSrcs(fileUrls);
  };

  return (
    <React.Fragment>
      <div>
        <Button component="label" variant="contained">
          <Translate id="select_file" />
          <input
            type="file"
            accept="image/*, video/*, audio/*"
            ref={fileRef}
            onChange={handleChangeFile}
            multiple
            hidden
          />
        </Button>
      </div>
      <div>
        {fileSrcs.map((fileSrc, fileIndex) => (
          <div key={createObjectURL(fileSrc)} styleName="image-thumbnail">
            <Badge
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              badgeContent={
                <IconButton
                  aria-label="delete"
                  onClick={() => {
                    const dt = new DataTransfer();
                    var files = fileRef.current.files;
                    var fileUrls = [];
                    for (var i = 0; i < files.length; i++) {
                      if (i !== fileIndex) {
                        dt.items.add(files[i]);
                        fileUrls.push(files[i]);
                      }
                    }
                    fileRef.current.files = dt.files;

                    setFileSrcs(fileUrls);
                  }}
                  size="large"
                >
                  <DeleteIcon />
                </IconButton>
              }
            >
              {["mp3", "ogg", "m4a"].some((str) => fileSrc.name.split(".").pop().includes(str)) ? (
                <audio controls src={createObjectURL(fileSrc)}></audio>
              ) : (
                <MediaThumbnail
                  image={createObjectURL(fileSrc)}
                  contentType={fileSrc.type}
                  local={true}
                />
              )}
            </Badge>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}
